import { createTheme } from "@mui/material/styles";

// Non-purple palette per user preference: deep teal primary + warm coral accent
export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#0E7C7B",
      light: "#3FA2A1",
      dark: "#075856",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#E76F51",
      light: "#F0A18C",
      dark: "#B14B33",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#F6F8F8",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#1B2A2A",
      secondary: "#586565",
    },
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    h1: { fontWeight: 600 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
    },
  },
});
